import * as React from "react"
import { cn } from "@/utils/cn"
import { cva, type VariantProps } from "class-variance-authority"

const inputVariants = cva(
  "w-full min-w-0 bg-transparent text-body-md transition-200 outline-none " +
  "placeholder:text-disabled selection:bg-brand-primary/10 " +
  "file:inline-flex file:h-8 file:border-0 file:bg-transparent",
  {
    variants: {
      size: {
        sm: "h-6 px-2 rounded-2",
        md: "h-8 px-3 rounded-2.5",
        lg: "h-10 px-4 rounded-3",
        lgx: "h-12 px-5 rounded-3.5",
      },
      'border-input': {
        true: 'border-input',
        false: '',
      },
    },
    defaultVariants: {
      size: "md",
      'border-input': true,
    },
  }
)

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", size, 'border-input': borderInput, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(inputVariants({ size, 'border-input': borderInput }), className)}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
